import { autoinject } from "aurelia-dependency-injection";
import Marionette from "../../shared/marionette-mustache";
import {SearchBoxModel} from "../../search/models/search-box";
import {SearchModel} from "../../search/models/search";
import {AppEvents} from "../../app-events";
import {QueryComponentModel} from "../../search/models/query-component";
declare var Beacon;
require("../styles/search-box.less");

const template = require<string>("../../search/views/search-box.html");

const dom = {
    SEARCH_BOX: "#search-box",
    SUGGESTION: ".suggestion",
    SEARCH_BUTTON: "#search-box-button",
    SEARCH_BOX_WIDGET: "#search-box-widget",
    SEARCH_BOX_WIDGET_CONTENT: "#search-widget-content",
    SEARCH_BOX_WIDGET_CLOSER: "#search-widget-closer",
    MOBILE_NAV_BAR: "#mobile-nav-region",
    ERROR_BAR: "#error-region",
    MOBILE_SETTINGS_BUTTON: "#mobile-settings-button",
    MOBILE_DOCUMENTS_BUTTON: "#mobile-documents-button",
    MOBILE_SEARCH_BUTTON: "#mobile-search-button",
    MOBILE_MYJUSTIS_BUTTON: "#mobile-my-justis-button",
    MOBILE_HELP_BUTTON: "#mobile-help-button",
    MOBILE_SIGN_OUT_BUTTON: "#mobile-name-sign-out"
};

const options = {
    template: template
};

@autoinject
export class SearchBoxView extends Marionette.ItemView<SearchBoxModel> {
    /** We have to change the html of the search box during mouseover, this is used to prevent bugs arising from double execution of mouseEnter  */
    private isMouseOverSearchBox = false;
    private suggestionsContainer: JQuery;

    constructor(private appEvents: Backbone.Events, public model: SearchBoxModel, searchModel: SearchModel) {
        super(options);
        model.searchModel = searchModel;
        this.setupModelChangeListeners();
    }

    public onShow() {
       _.defer(() => {
           this.setupSuggestionsContainer();
           this.setupPasteHandler();
           this.setupClickAndDragHandler();
           if (window.location.pathname.indexOf("search") !== -1) {
               this.placeCaretAtEnd();
           }
        });
    }

     public events(): Backbone.EventsHash {
         const events: Backbone.EventsHash = {};
         events[`keydown ${dom.SEARCH_BOX}`] = (e) => this.searchBoxKeyDownHandler(e);
         events[`click ${dom.SEARCH_BOX}`] = (e) => this.searchBoxClick(e);
         events[`mousedown ${dom.SEARCH_BOX}`] = (e) => this.searchMouseDown(e);
         events[`mouseup ${dom.SEARCH_BOX}`] = (e) => this.searchMouseUp(e);
         events[`mouseenter ${dom.SEARCH_BOX}`] = (e) => this.searchMouseEnter(e);
         events[`mouseleave ${dom.SEARCH_BOX}`] = (e) => this.searchMouseLeave(e);
         events[`click ${dom.SUGGESTION}`] = (e) => this.suggestionClick(e);
         events[`mousemove ${dom.SUGGESTION}`] = (e) => this.suggestionMouseEnter(e);
         events[`mouseleave ${dom.SUGGESTION}`] = (e) => this.suggestionMouseLeave(e);
         events[`click ${dom.SEARCH_BUTTON}`] = (e) => this.searchButtonClick();
         events[`click ${dom.SEARCH_BOX_WIDGET_CLOSER}`] = (e) => this.searchWidgetCloserClick(e);
         events["click " + dom.SEARCH_BOX_WIDGET] = (e) => this.searchBoxWidgetClick(e);
         events[`keyup ${dom.SEARCH_BOX}`] = (e) => this.searchBoxKeyUpHandler(e);
         events["mouseenter " + dom.ERROR_BAR] = (e) => this.model.searchModel.ErrorMessage = "";
         events[`mouseenter ${dom.SEARCH_BOX_WIDGET}`] = (e) => this.searchWidgetMouseEnter(e);
         events[`mouseleave ${dom.SEARCH_BOX_WIDGET}`] = (e) => this.searchWidgetMouseLeave(e);
         // Mobile Events
         events[`click ${dom.MOBILE_NAV_BAR}`] = () => this.toggleMobileNavDropdown();
         events[`click ${dom.MOBILE_SETTINGS_BUTTON}`] = () => this.toggleSettings();
         events[`click ${dom.MOBILE_DOCUMENTS_BUTTON}`] = () => this.toggleMobileDocumentList();
         events[`click ${dom.MOBILE_SEARCH_BUTTON}`] = () => Backbone.history.navigate(`search`, { trigger: true });
         events[`click ${dom.MOBILE_MYJUSTIS_BUTTON}`] = () => Backbone.history.navigate(`my-justis`, { trigger: true });
         events[`click ${dom.MOBILE_HELP_BUTTON}`] = () => this.helpButtonClick();
         events[`click ${dom.MOBILE_SIGN_OUT_BUTTON}`] = (e) => this.signoutClick(e);
         return events;
    }

    public searchWidgetMouseEnter(e: JQueryEventObject) {
        const html = this.model.ExpandedSearchWidgetContent;
        $("#search-widget-expanded-content").html(html);
        if (html) {
            $("#search-widget-expanded-content").show();
        }
    }

    public searchWidgetMouseLeave(e: JQueryEventObject) {
        $("#search-widget-expanded-content").hide();

    }

    public searchWidgetCloserClick(e: JQueryEventObject) {
        // the widget will disappear as a result of clearing all series
        e.stopPropagation();
        this.appEvents.trigger(AppEvents.AppInsightsSearchClearProductFilter, {ProductsCleared: this.model.searchModel.NumberOfSeriesSearched});
        this.model.searchModel.MaterialType = "";
        this.model.searchModel.Indicators = [];
        this.updateExpandedSearchWidgetContent();
        $("#search-widget-expanded-content").hide();
        this.fitSearchBox();
        this.model.triggerSearch();
    }

    public clearSearchBox() {
        // the widget will disappear as a result of clearing all series
        this.appEvents.trigger(AppEvents.AppInsightsSearchClearProductFilter, {ProductsCleared: this.model.searchModel.NumberOfSeriesSearched});
        this.model.searchModel.MaterialType = "";
        this.model.searchModel.Indicators = [];
        this.model.setSearchBoxContent("");
        this.updateExpandedSearchWidgetContent();
        $("#search-widget-expanded-content").hide();
        this.fitSearchBox();
    }

    public placeCaretAtEnd() {
        const el = this.$(dom.SEARCH_BOX).get(0);
        el.focus();
        if (typeof window.getSelection !== "undefined"
            && typeof document.createRange !== "undefined") {
            const range = document.createRange();
            range.selectNodeContents(el);
            range.collapse(false);
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (typeof (document.body as any).createTextRange !== "undefined") {
            const textRange = (document.body as any).createTextRange();
            textRange.moveToElementText(el);
            textRange.collapse(false);
            textRange.select();
        }
    }

    public updateExpandedSearchWidgetContent() {
        let matType = this.model.searchModel.MaterialType;
        if (matType && matType.length > 0) {
            matType = matType.toLowerCase() === "case" ? "Cases" : matType;
            $(dom.SEARCH_BOX_WIDGET_CONTENT).html(`<span id="widget-adv-label">Advanced Search</span> ${matType}`);
            $(dom.SEARCH_BOX_WIDGET).show();
        } else {
            $(dom.SEARCH_BOX_WIDGET).hide();
        }
        this.productsChanged();
        this.fitSearchBox();
    }

    private fitSearchBox() {
        _.defer(() => {
            let width = 60;
            const $widget = this.$(dom.SEARCH_BOX_WIDGET);
            if ($widget.is(":visible")) {
                width += $widget.outerWidth();
            }
            this.$(dom.SEARCH_BOX).css({width: `calc(100% - ${width}px)`});
        });
    }

    private searchBoxContentChanged(model: SearchBoxModel) {
        const $textBox = this.$(dom.SEARCH_BOX);
        $textBox.html(this.model.SearchBoxContent);
    }

    private suggestionMouseEnter(e: JQueryMouseEventObject) {
        this.suggestionsContainer.find(".selected").removeClass("selected");
    }

    private suggestionMouseLeave(e: JQueryMouseEventObject) {
        this.$(e.currentTarget).removeClass("selected");
    }

    private productsChanged() {
        const filters = [];

        this.model.searchModel.AdvancedSearch.AllProductFilters.forEach((f) => {
            if (f.Included === true) {
                filters.push(f);
            }
        });

        if (filters.length === this.model.searchModel.AdvancedSearch.AllProductFilters.length || filters.length === 0 ) {
            let label;

            switch (this.model.searchModel.MaterialType.toLowerCase()) {
                case "":
                case "all results":
                label = "All cases, legislation and EU";
                break;
                case "case":
                label = "All Cases";
                break;
                case "legislation":
                label = "All Legislation";
                break;
                case "eu":
                label = "All EU";
                break;
            }

            this.model.ExpandedSearchWidgetContent = `<h4 style="margin-bottom:0">Searching ${label}</h4>`;

        } else {

            const lis = filters.map((f) => {
                return `<li>${f.DisplayName}</li>`;
            });

            this.model.ExpandedSearchWidgetContent = `<h4>Searching </h4> <ul> ${lis.join("")}</ul>`;
        }

    }

    private setupModelChangeListeners() {
        this.listenTo(this.model, "SuggestionsChanged", this.updateSuggestions);
        this.listenTo(this.model, "change:SearchBoxContent", this.searchBoxContentChanged);
        this.listenTo(this.model, "change:AdvancedVisible", this.advancedVisibleChanged);
        this.listenTo(this.model.searchModel, "change:HighlightableSearchFragments", this.highlightRecognisedFragments);
        this.appEvents.on(AppEvents.HideSuggestions, () => {
            this.appEvents.trigger(AppEvents.CancelSuggestions);
            if (this.suggestionsContainer) { this.suggestionsContainer.hide(); }
        });
        this.appEvents.on(AppEvents.ClearSearchBox, () => {
             this.clearSearchBox();
        });
    }

    private highlightRecognisedFragments(model, components: QueryComponentModel[]) {
        $(dom.SEARCH_BOX).removeClass("search-cues-disabled");

        if (!components || components.length === 1 && components[0].Fragment === "") { return; }
        let htmlString = this.model.UserQuery;
        let index = 0;
        let offset = 0;
        for (const c of components) {
            if (this.shouldFragmentBeIgnored(c)) {
                continue; // Sometimes some junk comes back from the server eg "Space"
            }

            if (c.FieldName.toLowerCase() === "text") { c.FieldName = "ExtraTerms"; }

            const fragment = c.Fragment;
            const component = c.FieldName + "[" + fragment + "]";
            const replacement = (`<span data-uid="${c.id}" class="search-pill ${c.FieldName}" data-field="${c.FieldName}">${fragment}</span>`);

            index = htmlString.indexOf(fragment, offset);
            if (index !== -1) {
                offset = index + replacement.length - fragment.length;
                htmlString = this.replaceFragment(htmlString, fragment, replacement, index);
            } else {
                offset = component.length; // Skipping along the string without replacing fragment.
            }
        }
        this.model.setSearchBoxContent(htmlString);
        this.placeCaretAtEnd();
    }

    private replaceFragment(input: string, fragment: string, replacement: string, index: number) {
        const before = input.substring(0, index);
        const after = input.substring(index + fragment.length);
        return before + replacement + after;
    }

    private shouldFragmentBeIgnored(c: QueryComponentModel): boolean {
        if (c.FieldName.toLowerCase() === "text") { c.FieldName = "ExtraTerms"; }
        if (c.FieldName.toLowerCase() === "courtname") { c.FieldName = "Court"; }

        const validFields: string[] = ["Title", "Reference", "Citation", "FullText", "Category", "Court", "Year", "KeyPhrase", "ExtraTerms", "Judge", "Date"];
        if (c.Fragment.trim() === "" || c.FieldName === "Space" || c.FieldName === "Operator" || c.Fragment === "&nbsp;" || c.Fragment.length === 1) { // Sometimes a fragment "Space" comes back from server
            return true;
        }
        if (!_.contains(validFields, c.FieldName)) {
            return true;
        }
        return false;
    }

    private setupSuggestionsContainer() {
        this.suggestionsContainer = $("<ul class='suggestions-container'></ul>").appendTo("#search-box-container");
        this.suggestionsContainer.css({ position: "absolute" });
    }

    private updateSuggestions() {
        if (!this.suggestionsContainer) {
            return;
        }

        const suggestions = this.model.Suggestions;
        const query = this.model.UserQuery;
        if (!suggestions || suggestions.length === 0) {
            this.suggestionsContainer.hide().empty();
            return;
        }
        this.suggestionsContainer.empty().show();
        if (suggestions[0].SuggestionType === "Loading") {
            this.suggestionsContainer.html("<li class='suggestion loading'><span>Suggestions loading...</span></li>");
            return;
        }
        for (const suggestion of suggestions) {
            const html = this.createSuggestionHtml(query, suggestion);
            this.suggestionsContainer.append(html);
        }
    }

    private createSuggestionHtml(query: string, suggestionData: any) {
        const titleTokens = suggestionData.Label.toLowerCase().split(" ");
        const queryTokens = query.toLowerCase().split(" ");
        const trimmedQueryTokens = _.map(queryTokens, (q) => q.trim());
        const title = this.highlightTitleToken(trimmedQueryTokens, titleTokens.join(" "));
        const label = this.createSuggestionLabel(suggestionData.AdditionalLabel);
        const suggestionHtmlString = $(`<li class="suggestion ${suggestionData.SuggestionType}"><a><span class="term-title">${title}</span > ${label}</a></li>`);
        $(suggestionHtmlString).data(suggestionData.FieldValues);
        return suggestionHtmlString;
    }

    private createSuggestionLabel(label: string) {
        if (label) {
            if (label.length < 130) {
                return `<br /><span class="additional"> ${label} </span>`;
            } else {
                return `<br /><span class="additional"> ${label.substring(0, 130)}... </span>`;
            }
        }

        return "";
    }

    private highlightTitleToken(queryTokens: string[], title: string) {
        let found = false;
        const phrase = queryTokens.join(" ");
        if (title.indexOf(phrase) > -1) {
            const pattern = "(" + phrase.replace(/[|\\{}()[\]^S$+*?.]/g, "\\$&") + ")";
            title = title.replace(new RegExp(pattern, "i"), `<span class='term-match'>$1<\/span>`);
            found = true;
        }

        return title;
    }

    private get HasSelectedText() {
        let text = "";
        const activeEl = (document.activeElement as any);
        const activeElTagName = activeEl ? activeEl.tagName.toLowerCase() : null;
        if (
        (activeElTagName === "textarea") || (activeElTagName === "input" &&
        /^(?:text|search|password|tel|url)$/i.test(activeEl.type)) &&
        (typeof activeEl.selectionStart === "number")
        ) {
            text = activeEl.value.slice(activeEl.selectionStart, activeEl.selectionEnd);
        } else if (window.getSelection) {
            text = window.getSelection().toString();
        }
        return (text && text.length);
    }

    private escapeRegExp(str: string) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }

    private setupPasteHandler() {
        const self = this;  // need this for referencing inside the arrow function
        const $searchBox = this.$(dom.SEARCH_BOX);
        $searchBox.on("paste", function() {
            $searchBox.css({ opacity: 0 });
            _.defer(() => {
                $searchBox.html($(this).text());
                $searchBox.css({ opacity: 1 });
                self.placeCaretAtEnd();
                $(dom.SEARCH_BOX).trigger("keyup");
            });
        });
    }

    private setupClickAndDragHandler() {
        const self = this;  // need this for referencing inside the arrow function
        const $searchBox = this.$(dom.SEARCH_BOX);
        $searchBox.bind("drop", () => {
            _.defer(() => {
                // $(".form-field").trigger("keyup");
                $(dom.SEARCH_BOX).trigger("keyup"); // trigger this on all fields in case you're dragging from another field to this one
            });
        });
    }

    private searchMouseDown(e: JQueryMouseEventObject): boolean {
        if ($(e.currentTarget).hasClass("disabled")) {
            e.preventDefault();
            return false;
        }
    }

    private searchMouseUp(e: JQueryMouseEventObject): boolean {
        if ($(e.currentTarget).hasClass("disabled")) {
            e.preventDefault();
            return false;
        }
    }

    private searchMouseEnter(e: JQueryMouseEventObject): boolean {
        if (!this.isMouseOverSearchBox) {
            this.isMouseOverSearchBox = true;
            if ($(e.currentTarget).hasClass("disabled")) {
                e.preventDefault();
                return false;
            }
            const currentContent = this.$(dom.SEARCH_BOX).html();
        }
    }

    private searchMouseLeave(e: JQueryMouseEventObject): boolean {
        this.isMouseOverSearchBox = false;
        if ($(e.currentTarget).hasClass("disabled")) {
            e.preventDefault();
            return false;
        }
    }

    private searchBoxClick(e: JQueryMouseEventObject): void {
        if ($(e.currentTarget).hasClass("disabled")) {
            e.preventDefault();
            this.appEvents.trigger(AppEvents.CloseAdvanced);
            return;
        }
    }

    private suggestionClick(e: JQueryMouseEventObject): void {
        this.suggestionsContainer.find(".selected").removeClass("selected");
        $(e.currentTarget).addClass("selected");
        this.updateSearchBoxFromSuggestion();
        // this.model.searchModel.compileQueryComponentsFromTree();
        this.model.triggerSearch();
        this.model.clearSuggestions();
        this.placeCaretAtEnd();
    }

    private searchBoxKeyDownHandler(event: JQueryKeyEventObject): boolean {
        $(dom.SEARCH_BOX).addClass("search-cues-disabled");
        switch (event.keyCode) {
            case 40: // Down arrow
                event.preventDefault();
                return false;
            case 38: // Up arrow
                event.preventDefault();
                return false;
            default:
                return true;
        }
    }

    private searchBoxKeyUpHandler(event: JQueryEventObject) {
        this.model.KeyPressed = !this.model.KeyPressed;
        const textValue = this.$(event.currentTarget).text();
        switch (event.keyCode) {
            case 8: // backspace
            case 46: // delete
                this.backSpace(textValue, event);
                break;
            case 13: // enter
                event.preventDefault();
                this.enter();
                return false;
            case 40: // down
                event.preventDefault();
                this.arrowDown(event);
                return false;
            case 38: // up
                event.preventDefault();
                this.arrowUp();
                return false;
            case 27: // exc
                event.preventDefault();
                this.escape();
                return false;
            default:
                this.model.setUserQuery(textValue);
        }
    }

    private escape() {
        this.model.resetSearchBoxContent();
        this.model.clearSuggestions();
    }

     private enter() {
         if (this.model.searchModel.MiddlePagerEnter) {
             this.model.searchModel.MiddlePagerEnter = false;
         } else {
            this.model.triggerSearch();
            this.model.clearSuggestions();
            this.placeCaretAtEnd();
         }
    }

    private backSpace(textValue: string, event: JQueryEventObject) {
        if ($.trim(textValue) === "") {
            $(event.currentTarget).empty();
            this.model.trigger("ClearSearchCues");
        }
        this.model.setUserQuery(textValue);
    }

    private arrowUp() {
        const $active = this.suggestionsContainer.find(".selected").removeClass("selected");
        if ($active.length && !$active.is(":first-child")) {
            $active.prev().addClass("selected");
        } else if ($active.length && $active.is(":first-child")) {
            // Why is this here?
        } else {
            this.suggestionsContainer.find(".suggestion").last().addClass("selected");
        }
        this.updateSearchBoxFromSuggestion();
    }

    private updateSearchBoxFromSuggestion() {
        const $selected = this.suggestionsContainer.find(".selected");
        if (!$selected || !$selected.data()) {
            return;
        }
        this.model.updateSearchBoxContentFromSuggestion($selected.data());
        $(dom.SEARCH_BOX).removeClass("search-cues-disabled");
        this.placeCaretAtEnd();
    }

    private arrowDown(e: JQueryKeyEventObject) {
        const $active = this.suggestionsContainer.find(".selected").removeClass("selected");
        if ($active.length && !$active.is(":last-child")) {
            $active.next().addClass("selected");
        } else if ($active.length && $active.is(":last-child")) {
            // Why is this here?
        } else {
            this.suggestionsContainer.find(".suggestion").first().addClass("selected");
        }
        this.updateSearchBoxFromSuggestion();
    }

    private searchButtonClick(): void {
        this.model.searchModel.setAvailableDate(null, false);
        this.model.triggerSearch();
        this.model.clearSuggestions();
        this.appEvents.trigger(AppEvents.ClearCategoryFilter);
    }

    private advancedVisibleChanged(model: SearchBoxModel, visible: boolean): void {
        this.$(dom.SEARCH_BOX).toggleClass("advanced-enabled", visible);
    }

    private searchBoxWidgetClick(e) {
        if (!$(e.currentTarget).hasClass("subset")) { // only take you to advanced search if you're filtering.
            return;
        }
        Backbone.history.navigate("advancedsearch", {trigger: true});
    }

    private toggleMobileNavDropdown(): void {
        this.$("#mobile-dropdown-menu").dropdown();
    }

    private toggleSettings() {
        this.appEvents.trigger(AppEvents.SettingsVisibilityToggled);
    }

    private toggleMobileDocumentList() {
        this.appEvents.trigger(AppEvents.MobileDocumentListToggled);
    }

    private signoutClick(e: JQueryMouseEventObject) {
        e.stopPropagation();
        const signoutUrl = `signout`;
        Backbone.history.navigate(signoutUrl, { trigger: true, replace: true });
    }

    private helpButtonClick() {
        this.openHelpscoutBeacon();
        this.appEvents.trigger(AppEvents.AppInsightsDesktopHelpButton, {Button: "Clicked"});
    }

    private openHelpscoutBeacon(): void {
        Beacon("toggle");
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/search-box.ts